import { ampli } from '@/ampli';

import { buttons } from '@/styles/buttons';

import { TokenAvatar } from '@/ui/Avatars/TokenAvatar';

import { TokenResult } from '@/utils/0x/token-registry.types';
import { classNames } from '@/utils/classnames';

interface SwitchButtonProps {
  /** Inactive token  */
  inactiveToken?: TokenResult;
  /** Callback when a token is selected */
  onTokenSelect?: (token: TokenResult) => void;
  /** Active token */
  activeToken: TokenResult | undefined;
  /** Additional class name. */
  className?: string;
}

export const SwitchButton = ({
  inactiveToken,
  onTokenSelect,
  activeToken,
  className,
}: SwitchButtonProps) => {
  const onClick = () => {
    if (activeToken && inactiveToken) {
      onTokenSelect?.(inactiveToken);

      ampli.tokenSwitchClicked({
        token_chain_id: inactiveToken.chainId,
        token_chain_name: inactiveToken.chainName ?? '',
        token_address: inactiveToken.address,
        token_symbol: inactiveToken.symbol ?? '',
      });
    }
  };

  return inactiveToken ? (
    <button
      className={classNames(
        buttons({ shape: 'pill', color: 'gray', size: 'small', class: ['z-10', 'h-9'] }),
        className,
      )}
      onClick={onClick}
    >
      {activeToken?.chainId !== inactiveToken.chainId ? (
        <>
          <TokenAvatar address={inactiveToken.address} chainId={inactiveToken.chainId} size={16} />
          <span className="ml-1.5">
            Switch to {inactiveToken.symbol}
            <span className="text-token-gray-700"> on {inactiveToken.chainName}</span>
          </span>
        </>
      ) : (
        <>
          <TokenAvatar
            address={inactiveToken.address}
            chainId={inactiveToken.chainId}
            size={16}
            showChainLogo={false}
          />
          <span className="ml-1.5">Switch to {inactiveToken.symbol}</span>
        </>
      )}
    </button>
  ) : null;
};
